const sidebarAction = {
  SET_MENU: '@sidebarReducer/SET_MENU',
  MENU_TOGGLE: '@sidebarReducer/MENU_TOGGLE',
  MENU_OPEN: '@sidebarReducer/MENU_OPEN'
};

export default sidebarAction;
